import { render, staticRenderFns } from "./ProgramList.vue?vue&type=template&id=be7e4404&scoped=true&"
import script from "./ProgramList.vue?vue&type=script&lang=js&"
export * from "./ProgramList.vue?vue&type=script&lang=js&"
import style0 from "./ProgramList.vue?vue&type=style&index=0&id=be7e4404&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be7e4404",
  null
  
)

export default component.exports